<template>
  <section>
    <div v-lenis-scroll class="shopmaison-grid-container">
      <div class="section4inner">
        <div
          class="section4left imgsec2"
          :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
        >
          <div class="scrollingtext2">
            <h1 class="heading-text2">
              {{ shopifyData.sectionTitle }}
            </h1>

            <h1 class="heading-text2 heading-text2-res">
              {{ shopifyData.sectionTitle }}
            </h1>
            <a :href="shopifyData.buttonLink" class="heading-text-bottom2">{{
              shopifyData.buttonLabel
            }}</a>
          </div>
        </div>
      </div>

      <div class="content_grid gridd">
        <div />
        <!-- style="position: relative ;z-index: 10" -->
        <div>
          <div style="height: fit-content">
            <div class="scrollingtext-res-section2">
              <h1 class="heading-text-res-section2">
                {{ shopifyData.sectionTitle }}
              </h1>
              <a :href="shopifyData.buttonLink" class="heading-text-bottom-res-section2">{{
                shopifyData.buttonLabel
              }}</a>
            </div>
          </div>
          <!-- Right Grid Part  -->
          <div class="productsGrid rightside">
            <div v-for="(value, key) in shopifyData.productData" :key="key" class="grid_item">
              <a
                :href="value.product.productUrl"
                :product-id="value.product.productid"
                class="product_link"
              >
                <div class="grid_item_img">
                  <!-- Show preview image if showPreview is true, otherwise show product image -->
                  <img
                    v-lazy="
                      value.showPreview == 'true'
                        ? value.previewimage
                        : value.product.productidImage
                    "
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      backgroundImage: this.shopifyData.desktopBannerBg,
    };
  },
  mounted() {
    this.updateBackgroundImage(); // Call once when the component is mounted

    // Add a resize event listener
    window.addEventListener('resize', this.updateBackgroundImage);

    //Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    function animateSection(section) {
      ScrollTrigger.matchMedia({
        '(min-width: 769px)'() {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: section.querySelector('.section4inner'),
                scrub: 2,
                start: 'top top',
                end: '100% center',
              },
            })
            .to(
              section.querySelector('.section4inner'),
              {
                position: 'sticky',
                top: 0,
              },
              'b'
            )
            .to(
              section.querySelector('.scrollingtext2'),
              {
                margin: '0',
                duration: 1,
              },
              'b'
            );
        },
        '(max-width: 768px)'() {
          // console.log("this is on Mobile");
          gsap
            .timeline({
              scrollTrigger: {
                trigger: section.querySelector('.section4left'),
                start: '20% 20%',
                end: 'bottom -100%',
                scrub: true,
              },
            })
            .fromTo(
              section.querySelector('.section4left'),
              {
                backgroundSize: '150%',
              },
              {
                backgroundSize: '100%',
              }
            );
        },
        all() {
          ScrollTrigger.refresh();
        },
      });
    }

    // Apply animation to each section
    document.querySelectorAll('.shopmaison-grid-container').forEach((section) => {
      animateSection(section);
    });
  },
  beforeUnmount() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateBackgroundImage);
  },
  methods: {
    updateBackgroundImage() {
      if (window.innerWidth <= 676) {
        this.backgroundImage = this.shopifyData.mobBannerBg;
      } else {
        this.backgroundImage = this.shopifyData.desktopBannerBg;
      }
    },
  },
};
</script>

<style scoped>
.heading-text2 {
  color: white;
  text-wrap: nowrap;
  padding-top: 30%;
  font-size: 57px;
  font-style: italic;
  font-weight: 200;
  line-height: 1.43;
  text-align: center;
  font-family: 'PP Editorial New', sans-serif;
  /* Updated */
}

.grid_item_img img {
  display: block;
}

.rightside {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  backdrop-filter: blur(100px);
  background-image: linear-gradient(rgb(240 241 244), rgb(240 241 244));
  background-color: #f0f1f4;
}

.rightside img {
  width: 100%;
  height: 100%;
}

.secleft {
  position: relative;
}

.heading-text-bottom2 {
  color: #fff;
  font-family:
    Helvetica Neue,
    sans-serif;
  /* Updated */
  font-size: 14.99px;
  font-weight: 700;
  line-height: 13.64px;
  letter-spacing: 0.11em;
  text-align: center;
  text-wrap: nowrap;
  display: block;
}

.section4inner {
  position: relative;
}

.section4left {
  height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left;
}

.heading-text2-res {
  display: none;
}

.gridd {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  position: relative;
  z-index: 2;
}

.scrollingtext2 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  width: 50%;
  height: 100vh;
  margin: 0 auto;
}

.scrollingtext {
  display: flex;
}

.scrollingtext-res-section2 {
  display: none;
}

@media only screen and (max-width: 1150px) {
  .heading-text2 {
    font-size: 34px;
    line-height: 1.9;
  }

  .heading-text-bottom2 {
    font-size: 14px;
  }
}

@media only screen and (max-width: 1024px) {
  .heading-text,
  .heading-text-bottom,
  .heading-text2,
  .heading-text-bottom2 {
    text-align: center;
  }
}

@media only screen and (max-width: 768px) {
  .section4left {
    height: 100vh;
    width: 100%;
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
  }

  .scrollingtext {
    display: none;
  }

  .heading-text-res-section2 {
    padding-bottom: 134px;
    font-size: 30px;
    font-style: italic;
    font-weight: 200;
    line-height: 0.9;
    text-align: center;
    font-family: 'PP Editorial New', sans-serif;
    /* Updated */
  }

  .heading-text-bottom-res-section2 {
    font-family:
      Helvetica Neue,
      sans-serif;
    /* Updated */
    font-size: 14.99px;
    font-weight: 700;
    line-height: 13.64px;
    letter-spacing: 0.11em;
    text-align: center;
    color: #fff;
  }

  .scrollingtext-res-section2 {
    display: flex;
    flex-direction: column;
    gap: 123px;
    position: relative;
    z-index: 9;
    color: #ffffff;
    padding-bottom: 45px;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-right: 13px;
    padding-left: 14px;
  }

  .heading-text2-res {
    display: block;
    font-size: 34px;
    line-height: 60px;
    font-weight: 400;
    color: #fff;
    text-wrap: nowrap;
    padding-top: 30%;
  }

  .section4inner {
    position: sticky;
    top: 0;
  }

  .scrollingtext2 {
    display: none;
    justify-content: end;
    height: 98vh;
    margin: 0 auto;
    gap: 40%;
  }

  .gridd {
    grid-template-columns: 0% 100%;
  }

  .rightside {
    width: 100%;
    transform: translateX(0);
  }

  .heading-text2 {
    display: none;
    text-align: center;
    font-size: 36px;
    text-wrap: nowrap;
  }

  .heading-text-bottom2 {
    text-align: center;
    font-size: 15px;
    color: #fff;
  }
}
@media only screen and (max-width: 340px) {
  .heading-text-res-section2 {
    font-size: 26px;
  }
}
</style>
